import { z } from 'zod';

/**
 * Formato único de erro da API. O cockpit só precisa saber ler este objeto.
 * `codigo` é estável e serve para lógica; `mensagem` é texto pronto para a tela, em português.
 */
export const erroApiSchema = z.object({
  codigo: z.string(),
  mensagem: z.string(),
  /** Erros de validação campo a campo, quando houver. */
  campos: z.record(z.string(), z.string()).optional(),
});
export type ErroApi = z.infer<typeof erroApiSchema>;

export const CODIGOS_ERRO = {
  NAO_AUTENTICADO: 'nao_autenticado',
  SEM_PERMISSAO: 'sem_permissao',
  NAO_ENCONTRADO: 'nao_encontrado',
  DADOS_INVALIDOS: 'dados_invalidos',
  TRANSICAO_INVALIDA: 'transicao_invalida',
  CONFLITO: 'conflito',
  GATEWAY_PAGAMENTO: 'gateway_pagamento',
  INTERNO: 'interno',
} as const;
export type CodigoErro = (typeof CODIGOS_ERRO)[keyof typeof CODIGOS_ERRO];
